import useNewsTipCommentActions from './useNewsTipCommentActions'

export default useNewsTipCommentActions
